import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEmployeeData } from "./employeeSlice";

const useEmploymentInformation = () => {
  const dispatch = useDispatch();

  const { activeIndex, employmentInformation } = useSelector(
    (state) => state.employeeregister,
  );

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, employmentInformation]);

  const handleEnableNext = () => {
    if (activeIndex === 2) {
      if (
        employmentInformation.employee_identifier &&
        employmentInformation.start_date &&
        employmentInformation.employment_status &&
        employmentInformation.currency &&
        employmentInformation.salary
      ) {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };

  const onChangeEmploymentInformation = (name, value) => {
    dispatch(
      setEmployeeData({
        key: "employmentInformation",
        value: { ...employmentInformation, [name]: value },
      }),
    );
  };

  return {
    onChangeEmploymentInformation,
    employmentInformation,
  };
};

export default useEmploymentInformation;
